// extracted by mini-css-extract-plugin
module.exports = {"main":"Route_main__i1uK1","distance":"Route_distance__m2UVh","cityName":"Route_cityName__mYKUO"};